import { lazy } from "react";

const SupplierProfile = lazy(() => import("@pages/supplier/SupplierProfile"));
const SupplierPerformance = lazy(
  () => import("@pages/supplier/SupplierPerformance"),
);
const AssessmentTemplateLayout = lazy(
  () => import("@pages/supplier/AssessmentTemplate/Layout"),
);
const AdmissionAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/AdmissionAssessmentTemplate"
    ),
);
const PerformanceAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/PerformanceAssessmentTemplate"
    ),
);
const AppPerformanceAssessmentTemplate = lazy(
  () =>
    import(
      "@pages/supplier/AssessmentTemplate/components/PerformanceAssessmentTemplate/Edit"
    ),
);
const EmailInvite = lazy(
  () =>
    import(
      "@/pages/supplier/SupplierProfile/components/RegisteredTab/EmailInvite"
    ),
);

const ArchiveDetail = lazy(
  () =>
    import(
      /* webpackChunkName: "ArchiveDetail" */
      "@pages/supplier/SupplierProfile/archiveDetail"
    ),
);

const supplierRoute: RouteConfig[] = [
  {
    path: "/supplier", // 英文路径
    name: "supplier", // 英文 name 留给自己
    crumbTitle: "供应商管理", // 中文标题给面包屑
    component: SupplierProfile, // 默认显示档案页
    children: [
      {
        path: "/supplier/profile",
        name: "profile",
        crumbTitle: "供应商档案管理",
        component: SupplierProfile,
        children: [
          {
            path: "/supplier/profile/email-invite",
            name: "emailInvite",
            crumbTitle: "邮箱邀请",
            component: EmailInvite,
          },
          {
            path: "/supplier/profile/archive-detail",
            name: "archiveDetail",
            crumbTitle: "供应商档案详情",
            component: ArchiveDetail,
          },
        ],
      },
      {
        path: "/supplier/performance",
        name: "performance",
        crumbTitle: "供应商绩效管理",
        component: SupplierPerformance,
      },
      {
        path: "/supplier/assessment-template",
        name: "assessmentTemplate",
        crumbTitle: "评估模板管理",
        component: AssessmentTemplateLayout,
        children: [
          {
            path: "/supplier/assessment-template/admission",
            name: "admissionAssessmentTemplate",
            crumbTitle: "准入评估模板",
            component: AdmissionAssessmentTemplate,
          },
          {
            path: "/supplier/assessment-template/performance",
            name: "performanceAssessmentTemplate",
            crumbTitle: "绩效考核模板",
            component: PerformanceAssessmentTemplate,
          },
          {
            path: "/supplier/assessment-template/performance/edit",
            name: "addPerformanceAssessmentTemplate",
            crumbTitle: "添加模板",
            component: AppPerformanceAssessmentTemplate,
          },
        ],
      },
    ],
  },
];

export default supplierRoute;
